export default "__VITE_ASSET__CCaXOi41__"